
import { Options, Vue } from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import DaInfinityLoading from '@/components/common/daInfinityLoading/DaInfinityLoading.vue';
import { $api } from '@/services';
import SlideOverFeeNotices from '@/views/feeNotifications/SlideOverFeeNotices.vue';
import Loading from '@/components/common/Loading.vue';
import CreateNotify from '@/views/forms/CreateNotify.vue';
import FeePoper from './FeePoper.vue';

@Options({
	name: 'FeeNotices',
	components: {
		CreateNotify,
		Loading,
		SlideOverFeeNotices,
		DaInfinityLoading,
		FeePoper,
	},
	props: {
		feeNoticeAction: {
			type: Object,
			default: () => ({
				type: '',
				key: 0,
			}),
		},
	},
})
export default class FeeNotices extends Vue {
	notificationList: any = [];
	stopLoad = false;
	isInfinityLoading = false;
	sideOverShow = false;
	filter: any = {};
	isLoading = true;
	isFetching = false;
	beforeDate = '';
	listKey = 0;
	requestId = 0;
	type = '';

	//----------------------- 🤍 Created 🤍 -----------------------//
	created() {
		this.resetAndFetch();
	}

	@Watch('feeNoticeAction', { deep: true })
	onFeeNoticeAction(val: { type?: string; key?: number }) {
		if (val?.type) {
			this.openSideOver(val.type);
		}
	}

	//----------------------- 🤍 Methods 🤍 -----------------------//
	// BE returns at most one month per request: the latest month, or the
	// latest month before `before`. `month_start` returns only that month.
	async getNotificationList() {
		if (this.isFetching || this.stopLoad) return;
		this.isFetching = true;
		const requestId = this.requestId;
		try {
			const params = this.beforeDate
				? { ...this.filter, before: this.beforeDate }
				: { ...this.filter };
			const {
				data: { data },
			} = await $api.notification.getFeeNotificationsByMonth(params);
			if (requestId !== this.requestId) return;
			if (data && data.length > 0) {
				this.notificationList.push(...data);
				this.beforeDate = data[data.length - 1].month_start;
			} else {
				this.stopLoad = true;
			}
			if (this.filter.month_start) {
				this.stopLoad = true;
			}
			if (!this.stopLoad) {
				this.isInfinityLoading = true;
			}
		} catch (e) {
			console.log(e);
			if (requestId === this.requestId) this.stopLoad = true;
		} finally {
			if (requestId === this.requestId) {
				this.isLoading = false;
				this.isFetching = false;
			}
		}
	}

	resetAndFetch() {
		this.notificationList = [];
		this.beforeDate = '';
		this.stopLoad = false;
		this.isInfinityLoading = false;
		this.isLoading = true;
		this.isFetching = false;
		this.requestId++;
		this.listKey++;
		this.getNotificationList();
	}

	clean(obj: any) {
		for (let propName in obj) {
			if (
				obj[propName] === null ||
				obj[propName] === undefined ||
				obj[propName].length <= 0
			) {
				delete obj[propName];
			}
		}
		return obj;
	}

	filterSubmit(queryPa: any) {
		this.filter = queryPa ? this.clean({ ...queryPa }) : {};
		this.resetAndFetch();
		this.closeSideOver();
	}

	closeSideOver() {
		this.sideOverShow = false;
		this.type = '';
	}

	openSideOver(type: string) {
		this.sideOverShow = true;
		this.type = type;
	}
}
